module.exports = __webpack_public_path__ + "static/media/Review-Details.1a070e40.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/reviews/Review-Details.png
// module id = 124
// module chunks = 0